import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import activeFolderIcon from '../../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
import '../../styles/overview.scss'
import { MostVisitedFoldersTypes } from '../../core/_models'
import Skeleton from 'react-loading-skeleton'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'

const MostVisitedFolders = ({
  isLoading,
  mostVisitedFolders,
}: {
  isLoading: boolean
  mostVisitedFolders: MostVisitedFoldersTypes
}) => {
  const { formatMessage } = useIntl()
  const [modalContainer, setModalContainer] = useState<any>()
  const navigate = useNavigate()

  return (
    <div>
      <div className='d-flex justify-content-between align-items-center my-4 mt-8'>
        <h1 className='font-size-16'>{formatMessage({ id: 'Most Visited Folders' })}</h1>
        <Link to="/rk/overview/most-visited-folders" className='font-size-13 text-primary cursor-pointer'>
          {formatMessage({ id: 'View All' })}
        </Link>
      </div>
      {isLoading ? (
        <>
          <div className='d-md-flex d-none gap-4 flex-no-wrap overflow-auto hide-scrollbar' style={{ whiteSpace: 'nowrap' }}>
            {Array(5).fill(null).map((_, index) => (
              <Skeleton
                key={index}
                height={50}
                width={228}
                className=''
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ))}
          </div>
          <div className='d-md-none d-flex flex-column gap-4 flex-no-wrap overflow-auto hide-scrollbar' style={{ whiteSpace: 'nowrap' }}>
            {Array(5).fill(null).map((_, index) => (
              <Skeleton
                key={index}
                height={50}
                width={'100%'}
                className=''
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            ))}
          </div>
        </>
      ) : (
        <>
          {mostVisitedFolders.length > 0 ? (
            <div
              className='d-flex flex-md-row overflow-auto flex-column gap-4 hide-scrollbar flex-no-wrap'
              style={{ whiteSpace: 'nowrap' }}
            >
              {mostVisitedFolders.slice(0, 5).map((folder, index) => (
                <div
                  role='button'
                  key={index}
                  className='bg-white rounded p-4 d-flex align-items-center gap-4 cursor-pointer'
                  style={{ minWidth: '228px', minHeight: '50px' }}
                  onClick={() => navigate('/rk/records-and-files/' + encodeURIComponent(folder.path))}
                >
                  <img src={activeFolderIcon} alt={folder.name} />
                  <span ref={(node) => setModalContainer(node)}>
                    <OverlayTrigger
                      placement='bottom'
                      overlay={
                        <Tooltip id='tooltip'>
                          <p className='m-0'>{folder.name.split('.')[0]}</p>
                        </Tooltip>
                      }
                      container={modalContainer}
                    >
                      <p className='m-0 text-wrap'>
                        {folder.name.split('.')[0].length > 15
                          ? `${folder.name.split('.')[0].substring(0, 15)}...`
                          : folder.name.split('.')[0]}
                      </p>
                    </OverlayTrigger>
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <div
              className='d-flex justify-content-center align-items-center my-3'
              style={{ minHeight: '50px' }}
            >
              <p className='text-muted'>{formatMessage({ id: 'No folders found' })}</p>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default MostVisitedFolders
